import React from 'react';
import { TONES, toneStyle } from '../../lib/colorMeaning';

// A coloured pill that ALWAYS carries its words (colour is never the only signal).
export default function StatusChip({ tone = 'grey', children, icon = null, className = '', title }) {
    const key = Object.prototype.hasOwnProperty.call(TONES, tone) ? tone : 'grey';
    const fallback = toneStyle(key);
    return (
        <span
            data-tone={tone}
            title={title}
            style={{
                background: `var(--ia-status-${key}-bg, ${fallback.background})`,
                borderColor: `var(--ia-status-${key}-border, ${fallback.borderColor})`,
                color: `var(--ia-status-${key}-ink, ${fallback.color})`,
            }}
            className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-bold leading-5 ${className}`}
        >
            {icon}
            {children}
        </span>
    );
}

// Channels carry no colour: icon + word, white on the panel.
export function ChannelChip({ channel, className = '' }) {
    const names = { app_chat: 'App chat', sms: 'SMS', whatsapp: 'WhatsApp', email: 'Email', mms: 'MMS', push: 'Push', in_app: 'In-app', voice: 'Voice' };
    const key = String(channel || '').toLowerCase();
    const glyph = { app_chat: '💬', sms: '💬', mms: '💬', whatsapp: '🟢', email: '✉', push: '🔔', in_app: '🔔', voice: '📞' }[key] || '•';
    return (
        <span data-channel={key} className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full border border-slate-500 bg-transparent px-2.5 py-0.5 text-xs font-bold leading-5 text-white ${className}`}>
            <span aria-hidden="true">{key === 'whatsapp' ? '◎' : glyph}</span>
            {names[key] || channel}
        </span>
    );
}
